<template>
  <b-row>
    <b-col cols="12">
      <planning-orders-table />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import PlanningOrdersTable from './PlanningOrdersTable.vue'

export default {
  components: {
    BRow,
    BCol,

    PlanningOrdersTable,

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
